import { useCallback, useEffect, useRef } from "react";

export const useDebouncedSave = (delayMs = 600) => {
  const timersRef = useRef<Record<string, ReturnType<typeof setTimeout>>>({});

  useEffect(() => {
    const timers = timersRef.current;
    return () => {
      Object.values(timers).forEach(clearTimeout);
    };
  }, []);

  return useCallback(
    (key: string, saveFn: () => void | Promise<void>) => {
      if (timersRef.current[key]) {
        clearTimeout(timersRef.current[key]);
      }
      timersRef.current[key] = setTimeout(() => {
        void saveFn();
      }, delayMs);
    },
    [delayMs]
  );
};
